import { generalChecklistItems } from '../../constants/generalChecklistItems';
import { postSecondaryEducationChecklistItems } from '../../constants/postSecondaryEducationChecklistItems';
import { postSecondaryCareerChecklistItems } from '../../constants/postSecondaryCareerChecklistItems';
import { militaryChecklistItems } from '../../constants/militaryChecklistItems';
import { jobCorpsChecklistItems } from '../../constants/jobCorpsChecklistItems';
import { workforceChecklistItems } from '../../constants/workforceChecklistItems';
import { collegeChecklistItems } from '../../constants/collegeChecklistItems';
import { careerTrainingChecklistItems } from '../../constants/careerTrainingChecklistItems';
import { getChecklistItems } from '../../util/miscUtil';
import { PLANNING_MEETING_FORM_VERSION } from '../../constants/general';

// Utility to compute confirmed points earned for the Checklist form
export const computeConfirmedPointsEarned = (form) => {
  const version = form.version || PLANNING_MEETING_FORM_VERSION;
  let rc = 0;
  function sumConfirmed(items) {
    return items.reduce((sum, item) => {
      if (item.confirmKey && form[item.confirmKey]) {
        return sum + (item.points || 0);
      }
      return sum;
    }, 0);
  }

  // General checklist
  const generalItems = getChecklistItems(generalChecklistItems, { includeInstructions: false }, version);
  rc += sumConfirmed(generalItems);

  // Plan-specific checklists
  if (form.postGraduationPlan && form.postGraduationPlan.length > 0) {
    if (form.postGraduationPlan === 'post-secondary education') {
      const secedItems = getChecklistItems(postSecondaryEducationChecklistItems, { includeInstructions: false }, version);
      const collegeItems = getChecklistItems(collegeChecklistItems, { includeInstructions: false }, version);
      rc += sumConfirmed(secedItems);
      rc += sumConfirmed(collegeItems);
    } else if (form.postGraduationPlan === 'post-secondary career training') {
      const secCareerItems = getChecklistItems(postSecondaryCareerChecklistItems, { includeInstructions: false }, version);
      const careerTrainingItems = getChecklistItems(careerTrainingChecklistItems, { includeInstructions: false, includeGroupMembers: true }, version);
      rc += sumConfirmed(secCareerItems);
      rc += sumConfirmed(careerTrainingItems);
    } else if (form.postGraduationPlan === 'military') {
      const militaryItemsArr = getChecklistItems(militaryChecklistItems, { includeInstructions: false }, version);
      rc += sumConfirmed(militaryItemsArr);
    } else if (form.postGraduationPlan === 'Job Corps/AmeriCorps') {
      const jobcorpsItems = getChecklistItems(jobCorpsChecklistItems, { includeInstructions: false }, version);
      rc += sumConfirmed(jobcorpsItems);
    } else if (form.postGraduationPlan === 'workforce') {
      const workforceItemsArr = getChecklistItems(workforceChecklistItems, { includeInstructions: false }, version);
      rc += sumConfirmed(workforceItemsArr);
    } else if (form.postGraduationPlan === '4_year_college' || form.postGraduationPlan === '2_year_college') {
      const collegeItemsArr = getChecklistItems(collegeChecklistItems, { includeInstructions: false }, version);
      rc += sumConfirmed(collegeItemsArr);
    } else if (form.postGraduationPlan === 'career_training') {
      const careerItemsArr = getChecklistItems(careerTrainingChecklistItems, { includeInstructions: false, includeGroupMembers: true }, version);
      rc += sumConfirmed(careerItemsArr);
    }
  }
  return rc;
};
